import { useMemo } from 'react';
import { useFetchAllOnPageSeoTestsQuery } from '../service';
import { PartialFailedCheck } from '../types';

type Params = {
    partialFailedChecks: PartialFailedCheck[];
    totalUrlsCount?: number;
};

export default function useHydrateFailedChecks({ partialFailedChecks, totalUrlsCount }: Params) {
    const { data: seoTestsDetails, isLoading: isLoadingSeoTestsDetails } = useFetchAllOnPageSeoTestsQuery();

    const failedChecksWithDetails = useMemo(
        () =>
            seoTestsDetails
                ? partialFailedChecks.map((check) => ({
                    ...check,
                    relevance: seoTestsDetails[check.testKey].relevance,
                    title: seoTestsDetails[check.testKey].title,
                    recommendation: seoTestsDetails[check.testKey].recommendation,
                    seoIssue: seoTestsDetails[check.testKey].seo_issue,
                    impactScore: seoTestsDetails[check.testKey].relevance * (totalUrlsCount ? check.affectedUrls / totalUrlsCount : 1),
                    howToFix: seoTestsDetails[check.testKey].how_to_fix,
                }))
                : [],
        [seoTestsDetails, partialFailedChecks, totalUrlsCount]
    ).filter((check) => check.relevance !== undefined && check.relevance > 0); // Filter out failed checks with zero relevance

    const isLoadingFailedChecksDetails = isLoadingSeoTestsDetails;

    return {
        failedChecksWithDetails,
        isLoadingFailedChecksDetails,
    };
}
